namespace Matrix.Data {
    export interface TestResultMutingForm {
        BatchId: Serenity.IntegerEditor;
        TestCode: Serenity.StringEditor;
        MuteId: Serenity.IntegerEditor;
        UntilWhen: Serenity.DateEditor;
        Comment: Serenity.TextAreaEditor;
    }

    export class TestResultMutingForm extends Serenity.PrefixedContext {
        static formKey = 'Data.TestResultMuting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TestResultMutingForm.init)  {
                TestResultMutingForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.TextAreaEditor;

                Q.initFormType(TestResultMutingForm, [
                    'BatchId', w0,
                    'TestCode', w1,
                    'MuteId', w0,
                    'UntilWhen', w2,
                    'Comment', w3
                ]);
            }
        }
    }
}
